import { render, staticRenderFns } from "./SystemMessageDetail.vue?vue&type=template&id=160456ec&scoped=true"
import script from "./SystemMessageDetail.vue?vue&type=script&lang=js"
export * from "./SystemMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./SystemMessageDetail.vue?vue&type=style&index=0&id=160456ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160456ec",
  null
  
)

export default component.exports